import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import blogApi, { fileUrl } from "../apiProvider/blog";

const BlogLayer = () => {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const loadBlogs = async () => {
    setLoading(true);
    try {
      const data = await blogApi.list({ page: 0, limit: 100, search, status });
      setBlogs(data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBlogs();
  }, []);

  const handlePublishToggle = async (blog) => {
    if (blog.status === "published") await blogApi.unpublish(blog._id);
    else await blogApi.publish(blog._id);
    loadBlogs();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this blog post?")) return;
    await blogApi.remove(id);
    loadBlogs();
  };

  return (
    <div className="card">
      <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
        <div>
          <h6 className="mb-0">Blog Management</h6>
          <small className="text-secondary-light">Create SEO blogs, upload media, and publish to the website.</small>
        </div>
        <Link to="/blog-add" className="btn btn-primary-600">
          <i className="ri-add-line" /> Add Blog
        </Link>
      </div>
      <div className="card-body">
        <div className="d-flex flex-wrap gap-12 mb-24">
          <input className="form-control" style={{ maxWidth: 320 }} placeholder="Search blogs" value={search} onChange={(e) => setSearch(e.target.value)} />
          <select className="form-control" style={{ maxWidth: 180 }} value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">All Status</option>
            <option value="draft">Draft</option>
            <option value="published">Published</option>
          </select>
          <button className="btn btn-outline-primary-600" onClick={loadBlogs}>Filter</button>
        </div>

        {loading ? (
          <p className="mb-0">Loading blogs...</p>
        ) : (
          <div className="table-responsive">
            <table className="table bordered-table mb-0">
              <thead>
                <tr>
                  <th>Post</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Keyword</th>
                  <th>Published</th>
                  <th className="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {blogs.length === 0 && <tr><td colSpan="6" className="text-center">No blog posts found.</td></tr>}
                {blogs.map((blog) => (
                  <tr key={blog._id}>
                    <td>
                      <div className="d-flex align-items-center gap-12">
                        <img src={fileUrl(blog.coverImage) || "assets/images/blog/blog1.png"} alt="" className="w-56-px h-56-px radius-8 object-fit-cover" />
                        <div>
                          <div className="fw-semibold text-neutral-900">{blog.title}</div>
                          <small className="text-secondary-light">/{blog.slug}</small>
                        </div>
                      </div>
                    </td>
                    <td>{blog.category?.name || "-"}</td>
                    <td>
                      <span className={`badge ${blog.status === "published" ? "bg-success-100 text-success-600" : "bg-warning-100 text-warning-600"}`}>
                        {blog.status}
                      </span>
                    </td>
                    <td>{blog.focusKeyword || "-"}</td>
                    <td>{blog.publishedAt ? new Date(blog.publishedAt).toLocaleDateString() : "-"}</td>
                    <td>
                      <div className="d-flex justify-content-end gap-8">
                        <Link to={`/blog-details/${blog._id}`} className="btn btn-sm btn-outline-info">Preview</Link>
                        <Link to={`/blog-edit/${blog._id}`} className="btn btn-sm btn-outline-primary">Edit</Link>
                        <button className="btn btn-sm btn-outline-success" onClick={() => handlePublishToggle(blog)}>
                          {blog.status === "published" ? "Unpublish" : "Publish"}
                        </button>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(blog._id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogLayer;
